/*
 * @Description:
 * @Date: 2019-12-31 14:53:13
 */
import { priceFilterForTools } from '@/tools/formCheck';
export const dbCon = {
  data() {
    return {
      formKey: 1
    };
  },
  methods: {
    setLocalProjectStatus(type) {
      if (type != 0) {
        this.ruleForm.projectStatus = 3;
        this.ruleForm.auditStatus = 1;
      }
    },
    db() {
      const next = (resolve, reject) => {
        this.$confirm('是否确认提交项目信息', '提示', {
          confirmButtonText: '提交',
          cancelButtonText: '返回',
          type: 'warning'
        })
          .then(async () => {
            try {
              await this.submitForm('ruleForm', 1);
              resolve('submit_success');
            } catch (error) {
              reject('submit_error');
            }
          })
          .catch(() => {
            reject('submit_error');
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
      };
      const formValidate = (this.$refs['ruleForm'] || {}).validate;
      return new Promise((resolve, reject) => {
        if (typeof formValidate === 'function') {
          formValidate(async valid => {
            if (valid) {
              next(resolve, reject);
            } else {
              reject('submit_error');
            }
          });
        } else {
          next(resolve, reject);
        }
      });
    }
  },
  computed: {
    isConfirm() {
      const { projectStatus, auditStatus } = this.ruleForm;
      return projectStatus == 3 && auditStatus == 3;
    },
    ifDisable() {
      const { projectStatus, auditStatus } = this.ruleForm;
      return (
        projectStatus < 2 ||
        (projectStatus == 3 && [1, 3].includes(+auditStatus))
      );
    }
  },
  created() {},
  watch: {
    '$route.query.id': {
      handler() {
        this.formKey++;
        (this.$options.created || []).forEach(fn => fn.call(this));
      }
    },
    'ruleForm.taxCollectionPattern': {
      handler(newV) {
        if (newV == 9) {
          // 工具类型项目
          ['price'].forEach(item => {
            if (
              Array.isArray(this.rules[item]) &&
              Object.prototype.toString.call(this.rules[item][0]) ===
                '[object Object]'
            ) {
              this.rules[item][0].validator = priceFilterForTools;
            }
          });
        }
      },
      deep: true
    }
  }
};
